import { render, staticRenderFns } from "./ed-video-viewer.vue?vue&type=template&id=43547010&scoped=true&"
import script from "./ed-video-viewer.ts?vue&type=script&lang=js&"
export * from "./ed-video-viewer.ts?vue&type=script&lang=js&"
import style0 from "./ed-video-viewer.scss?vue&type=style&index=0&id=43547010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43547010",
  null
  
)

export default component.exports